var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustody = function SvgCustody(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 .25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 6 .25ZM14 .25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 14 .25ZM4.25 10A.75.75 0 0 1 5 9.25h8a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75ZM4.25 14a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
    fill: "#083A71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.957 1.751A.751.751 0 0 1 6 1.75h8a.75.75 0 0 1 .04.001c1.728.093 3.23.475 4.267 1.628 1.022 1.137 1.443 2.864 1.443 5.271V15a.75.75 0 0 1-1.5 0V8.65c0-2.293-.414-3.551-1.059-4.269-.629-.7-1.621-1.043-3.211-1.131H6.021c-1.592.093-2.584.437-3.213 1.136-.645.716-1.059 1.97-1.059 4.264v6.17c0 2.05.262 3.343.947 4.15.657.774 1.873 1.28 4.303 1.28h6a.75.75 0 0 1 0 1.5H7c-2.57 0-4.354-.524-5.447-1.81C.488 18.688.25 16.89.25 14.82V8.65c0-2.407.42-4.132 1.444-5.268 1.035-1.15 2.537-1.532 4.263-1.63Z",
    fill: "#083A71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.28 16.28c-.31.31-.53.836-.53 1.72v1.19l3.44-3.44H16c-.884 0-1.41.22-1.72.53Zm-1.06-1.06c.69-.69 1.664-.97 2.78-.97h3a.75.75 0 0 1 .53 1.28l-6 6a.75.75 0 0 1-1.28-.53v-3c0-1.116.28-2.09.97-2.78Z",
    fill: "#083A71"
  })));
};
export default SvgCustody;